/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Event_Related_LabelInputs */



/**
* | output |
* | --- |
* | "Event-related" |
*
* @param {Manual_Qc_Event_Related_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_event_related_label = /** @type {((inputs?: Manual_Qc_Event_Related_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Event_Related_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lie a un evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("ereignisbezogen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Correlato all'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Событийные")
	if (locale === "es") return /** @type {LocalizedString} */ ("Relacionado con eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件相关")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント関連")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटना से संबंधित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Relacionado a eventos")
	return /** @type {LocalizedString} */ ("Event-related")
});